import { useEffect } from 'react'

import { useGlobalState } from '@pepper/ui'

import { useSubscriptionDetails } from '@pepper/utils/src/api/subscriptions/useSubscriptionDetails'
import { dataLayerSubscriptionEvent } from '@pepper/utils/src/function/dataLayerEvents'

export const useSetPermissions = (companyId: string) => {
  const { setPermissions, setSubscription, setTrialExhaust } = useGlobalState()
  const { data: subscriptionDetails } = useSubscriptionDetails(companyId)

  useEffect(() => {
    if (subscriptionDetails) {
      const { capabilities, subscription } = subscriptionDetails

      setPermissions?.({
        aiContentCreation:
          capabilities['ai-content-creation']?.enabled ?? false,
        aiMatch: capabilities['pepper-cloud-ai-match']?.enabled ?? false,
        cmsPublish: capabilities['cms-publish']?.enabled ?? false,
        contentBrief: capabilities['content-briefs']?.enabled ?? false,
        gscGaIntegration: capabilities['gsc-ga-integrations']?.enabled ?? false,
        preEdit: capabilities['is_preedit_enabled']?.enabled ?? false,
        marketplace: capabilities['marketplace']?.enabled ?? false,
        marketplaceOrderManagement:
          capabilities['marketplace-order-management']?.enabled ?? false,
        collaboration:
          capabilities['is_collaboration_enabled']?.enabled ?? false,
        deliveryAnalytics:
          capabilities['is_delivery_analytics_enabled']?.enabled ?? false,
        favouriteCreator: capabilities['favorite-creators']?.enabled ?? false,
        cmp: capabilities['cmp']?.enabled ?? false,
        interlinking: capabilities['interlinking']?.enabled ?? false,
        keywords: capabilities['keywords']?.enabled ?? false,
        topics: capabilities['topics']?.enabled ?? false,
        seoPositionTracking:
          capabilities['keyword-position-tracking']?.enabled ?? false,
        seoAnalytics: capabilities['seo-analytics']?.enabled ?? false,
        seoContentResearch:
          capabilities['content-research-reports']?.enabled ?? false,
        seoContentRefresh:
          capabilities['seo-content-refresh']?.enabled ?? false,
        pepperDoc: capabilities['pepper-docs']?.enabled ?? false,
        plagiarism: capabilities['plagiarism-detection']?.enabled ?? false,
        marketplacePlagiarism:
          capabilities['marketplace-plagiarism-detection']?.enabled ?? false,
        referenceCheck: capabilities['reference-checks']?.enabled ?? false,
        seoWritingAssistant:
          capabilities['seo-writing-assistant']?.enabled ?? false,
        teamManagement: capabilities['team-management']?.enabled ?? false,
        topicSuggestion: capabilities['topic-suggestions']?.enabled ?? false,
      })

      if (subscription?.plan) {
        dataLayerSubscriptionEvent({
          planKey: subscription.plan.key,
          planName: subscription.plan.name,
          planStatus: subscription.status,
        })
        setSubscription?.({
          key: subscription.plan.key,
          name: subscription.plan.name,
          status: subscription.status,
          trialStatus: subscription.trial_status,
        })
      }

      setTrialExhaust({
        aiContentCreation:
          capabilities['ai-content-creation']?.is_limit_exhausted ?? false,
        keywords: capabilities['keywords']?.is_limit_exhausted ?? false,
        topics: capabilities['topics']?.is_limit_exhausted ?? false,
        seoPositionTracking:
          capabilities['keyword-position-tracking']?.is_limit_exhausted ??
          false,
        seoContentResearch:
          capabilities['content-research-reports']?.is_limit_exhausted ?? false,
        seoContentRefresh:
          capabilities['seo-content-refresh']?.is_limit_exhausted ?? false,
        teamManagement:
          capabilities['team-management']?.is_limit_exhausted ?? false,
      })
    }
  }, [subscriptionDetails, setPermissions, setSubscription, setTrialExhaust])
}
